import {request} from '../utils/request';
import { rbacApi } from '../config/urlConfig';
export const findPermission = (data: any) =>
  request({
    url: `${rbacApi}/permission/list`,
    method: 'post',
    data,
  });

// 查找菜单
export const findPermissionByRole = (data: any) =>
  request({
    url: `${rbacApi}/permission/listByRole`,
    method: 'post',
    data,
  });
export const findPermissionById = (data: any) =>
  request({
    url: `${rbacApi}/permission/info`,
    method: 'post',
    data,
  });


// 检测输入的路径（路由）是否存在、是否有权访问、是工作台还是官网页面
export const checkPath = (data: { path: string }) =>
  request({
    url: `${rbacApi}/permission/checkpath`,
    method: 'post',
    data,
  });


export const findMenuPermissionByDomainCode = (data: { domainModelCode: string }) =>
  request({
    url: `${rbacApi}/permission/findMenuPermissionByDomainCode`,
    method: 'post',
    data,
  });
